export default class Text {
  constructor(publisherSettings) {
    this.theme = publisherSettings?.theme || {};
  }

  defaultMappings() {
    return {
      editors_pick_heading_text: "Editor's Picks",
      promoted_events_heading_text: 'Promoted Events',
      featured_events_heading_text: 'Featured Events',
      other_events_heading_text: 'Other Events',
      featured_events_badge_text: 'Featured',
      editors_pick_badge_text: "Editor's Pick",
      buy_tickets_badge_text: 'Buy Tickets Now',
    };
  }

  for(key) {
    const settings_api_key = `plugin_${key}`;
    if (this.theme[settings_api_key]) {
      return this.theme[settings_api_key];
    }
    return this.defaultMappings()[key];
  }
}
